import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatMessage } from '../../../domain/messages/models/ChatMessage';
import { ChatMessagesState, initialChatMessagesState } from './chatMessagesState';
import { ChatCitation } from '../../../domain/messages/models/ChatCitation';
import { TokenUsage } from '../../../services/providers/progpt/dtos/responses/ProGPTSendMessageResponseDto';
// import { TokenUsage } from '../../../services/providers/progpt/dtos/responses/ProGPTSendMessageResponseDto';

export interface SetMessagesPayload {
	sessionId: string;
	messages: ChatMessage[];
}

const chatMessagesSlice = createSlice({
	name: 'chatMessages',
	initialState: initialChatMessagesState,
	reducers: {
		setMessages: (state: ChatMessagesState, action: PayloadAction<SetMessagesPayload>) => {
			state.bySessionId[action.payload.sessionId] = action.payload.messages;
		},
		appendMessages: (state: ChatMessagesState, action: PayloadAction<SetMessagesPayload>) => {
			const current = state.bySessionId[action.payload.sessionId] ?? [];
			state.bySessionId[action.payload.sessionId] = [...current, ...action.payload.messages];
		},
		prependMessages: (state: ChatMessagesState, action: PayloadAction<SetMessagesPayload>) => {
			const current = state.bySessionId[action.payload.sessionId] ?? [];
			state.bySessionId[action.payload.sessionId] = [...action.payload.messages, ...current];
		},
		updateMessageContent: (
			state: ChatMessagesState,
			action: PayloadAction<{ sessionId: string; messageId: string; content: string }>,
		) => {
			const messages = state.bySessionId[action.payload.sessionId];
			if (!messages) return;
			const msg = messages.find((m) => m.id === action.payload.messageId);
			if (msg) {
				msg.content = action.payload.content;
			}
		},
		updateCitations: (
			state: ChatMessagesState,
			action: PayloadAction<{ sessionId: string; messageId: string; content: ChatCitation[] }>,
		) => {
			const messages = state.bySessionId[action.payload.sessionId];
			if (!messages) return;
			const msg = messages.find((m) => m.id === action.payload.messageId);
			if (msg) {
				msg.citations = action.payload.content;
			}
		},
		updateMessageInfo: (
			state: ChatMessagesState,
			action: PayloadAction<{ sessionId: string; messageId: string; agentSources: string[], tokenInfo: TokenUsage | undefined }>,
		) => {
			const messages = state.bySessionId[action.payload.sessionId];
			if (!messages) return;
			const msg = messages.find((m) => m.id === action.payload.messageId);
			if (msg) {
				msg.agentSources = action.payload.agentSources;
				msg.tokenUsage = action.payload.tokenInfo;
			}

		},
		clearMessages: (state: ChatMessagesState, action: PayloadAction<string>) => {
			delete state.bySessionId[action.payload];
		},
		removeMessage: (state: ChatMessagesState, action: PayloadAction<{ sessionId: string; messageId: string }>) => {
			const messages = state.bySessionId[action.payload.sessionId];
			if (!messages) return;
			state.bySessionId[action.payload.sessionId] = messages.filter((m) => m.id !== action.payload.messageId);
		},
	},
});

export const { setMessages, appendMessages, prependMessages, updateMessageContent, updateCitations, clearMessages, removeMessage, updateMessageInfo } = chatMessagesSlice.actions;

export default chatMessagesSlice.reducer;
